export const props_place_5 = (val) => (!!val.match(/\D/g) ? val : Number(val) - 2 >= 1 ? String(Number(val) - 2) : val);
export const props_place_4 = (val) => (!!val.match(/\D/g) ? val : Number(val) - 3 >= 1 ? String(Number(val) - 3) : val);
